module.exports = __webpack_public_path__ + "img/03n.196ff15d.svg";